import { render, staticRenderFns } from "./MixinsPage.vue?vue&type=template&id=2ab00c6e&scoped=true&"
import script from "./MixinsPage.vue?vue&type=script&lang=js&"
export * from "./MixinsPage.vue?vue&type=script&lang=js&"
import style0 from "./MixinsPage.vue?vue&type=style&index=0&id=2ab00c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab00c6e",
  null
  
)

export default component.exports